import React from 'react'
import ColorSelect from './color-select'
import { useMutation } from '@apollo/client'
import fetchGroups from '../queries/group-list'
import createGroup from '../mutations/create-group'
import updateGroup from '../mutations/update-group'

function GroupForm(props) {
  const [isEdit, setIsEdit] = React.useState(!!props.name)
  const [name, setName] = React.useState(props.name)
  const [color, setColor] = React.useState(props.color || '5A6175')
  const [createGroupMutation] = useMutation(createGroup)
  const [updateGroupMutation] = useMutation(updateGroup)
  const prevNameRef = React.useRef(props.color || '5A6175')

  const resetState = () => {
    setIsEdit(!!props.name)
    setName(props.name)
    setColor(props.color || '5A6175')
  }

  React.useEffect(() => {
    if (props.name !== prevNameRef) resetState()
  }, [props])

  const navigateToSectionsNew = (groupId) => {
    const { search } = window.location
    window.location.href = `/groups/${groupId}/sections/new${search}`
  }

  const handleChange = (event) => {
    setName(event.target.value)
  }

  const handleSubmit = (event) => {
    event.preventDefault()

    const { id, dismiss } = props

    if (isEdit) {
      updateGroupMutation({
        refetchQueries: [{ query: fetchGroups }],
        variables: { id, name, color },
      }).then(dismiss)
    } else {
      createGroupMutation({
        variables: { name, color },
      }).then(({ data }) => {
        navigateToSectionsNew(data.createGroup.id)
      })
    }
  }
  const { isActive, dismiss } = props
  const activeClass = isActive ? 'group-card form active' : 'group-card form'
  const title = isEdit ? 'Edit Group' : 'Create New Group'
  const saveText = isEdit ? 'Save' : 'Save And Add Section'

  return (
    <div className={activeClass} onClick={(e) => e.stopPropagation()}>
      <div className="group-form-header">
        {title}
        <div className="dismiss" onClick={dismiss}>
          <i className="material-icons">close</i>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="field floating">
          <input
            type="text"
            name="name"
            value={name}
            onChange={handleChange}
            required
          />
          <div className="highlight" />
          <label>Course Name</label>
        </div>
        <ColorSelect color={color} onSelect={(c) => setColor(c)} />
        <button className="group-save">{saveText}</button>
      </form>
    </div>
  )
}

export default GroupForm
